import { useCalendarPickerStyles_unstable } from '../CalendarPicker/useCalendarPickerStyles';
/**
 * @internal
 *
 * Apply styling to the CalendarYear slots based on the state
 */
export const useCalendarYearStyles_unstable = props => {
  return useCalendarPickerStyles_unstable(props);
};
//# sourceMappingURL=useCalendarYearStyles.js.map